import { render, staticRenderFns } from "./DeviceAverageRatingReviewsSkeleton.vue?vue&type=template&id=ee9dacb2&"
import script from "./DeviceAverageRatingReviewsSkeleton.vue?vue&type=script&lang=js&"
export * from "./DeviceAverageRatingReviewsSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee9dacb2')) {
      api.createRecord('ee9dacb2', component.options)
    } else {
      api.reload('ee9dacb2', component.options)
    }
    module.hot.accept("./DeviceAverageRatingReviewsSkeleton.vue?vue&type=template&id=ee9dacb2&", function () {
      api.rerender('ee9dacb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/devicereviews/DeviceAverageRatingReviewsSkeleton.vue"
export default component.exports